import { render, staticRenderFns } from "./viewConfig.vue?vue&type=template&id=054631fc"
import script from "./viewConfig.vue?vue&type=script&lang=js"
export * from "./viewConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports